// extracted by mini-css-extract-plugin
export default {"HoverDesc":"HoverDescNode_HoverDesc__2FWYz","description":"HoverDescNode_description__+MjWe"};